import React, { useEffect, useState, useCallback, useMemo } from 'react'
import HtmlRenderer from 'Utils/htmlRenederer.utils'
import { ATTRIBUTE_TYPES } from 'Constants/attributes.constants'
import { InstructionType } from 'Types/Tasks.types'
import SelectAttribute from 'Components/attributes/SelectAttribute/Select'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import UnorderedList from 'Assets/icons/unordered-list.svg'
import style from './TaskInstruction.module.less'

type TaskInstructionProps = {
    instructions: InstructionType[]
    title: string
}

const TaskInstruction: React.FC<TaskInstructionProps> = props => {
    const [selectedValue, setSelectedValue] = useState<string>('')
    const [htmlContent, setHtmlContent] = useState<string>('')

    useEffect(() => {
        setSelectedValue(props.instructions[0]?.label ?? '')
        setHtmlContent(
            props.instructions[0]?.content ?? 'No instructions were provided for this task'
        )
    }, [props.instructions])

    const handleChange = useCallback(
        (val: string | undefined) => {
            if (val) {
                setSelectedValue(val)
                setHtmlContent(props.instructions.find(i => i.label === val)?.content ?? '')
            }
        },
        [props.instructions]
    )

    const selectAttributeMemo = useMemo(() => {
        if (props.instructions.length <= 1) {
            return null
        }
        return (
            <SelectAttribute
                value={selectedValue}
                options={props.instructions.map(i => ({ label: i.label, value: i.label }))}
                width={'20%'}
                onChange={handleChange}
                className={style['task-instruction-select']}
                id={'task-instructions'}
                label={''}
                type={ATTRIBUTE_TYPES.SELECT}
            />
        )
    }, [selectedValue, props.instructions, handleChange])

    return (
        <div className={style['task-instruction']} data-testid="task-instructions-container">
            <PanelHeader title={props.title} logo={UnorderedList} />
            <div className={style['task-instruction-body']}>
                <div className={style[`${selectAttributeMemo}?? task-instruction-select`]}>
                    {selectAttributeMemo}
                </div>
                <div className={style['task-instruction-content']}>
                    <HtmlRenderer className={'TaskInstruction'} htmlContent={htmlContent} />
                </div>
            </div>
        </div>
    )
}
export default TaskInstruction
